import { useState } from 'react'

export interface SelectItem {
  id: string | number
  name: string
  sub?: string
}

interface Props {
  items: SelectItem[]
  selectedName?: string
  onPick: (item: SelectItem) => void
  onClear: () => void
  placeholder: string
  className?: string
}

const fieldCls = 'border border-zinc-300 bg-transparent px-2 py-1.5 text-sm w-full focus:outline-none focus:border-zinc-900'

export function SearchSelectInput({ items, selectedName, onPick, onClear, placeholder, className }: Props) {
  const [query, setQuery] = useState('')
  const [focused, setFocused] = useState(false)

  const filtered = query.trim()
    ? items.filter((i) => i.name.toLowerCase().includes(query.toLowerCase()))
    : items
  const matches = filtered.slice(0, 8)

  if (selectedName) {
    return (
      <div className={`flex items-center gap-2 border border-zinc-300 px-2 py-1.5 text-sm ${className ?? ''}`}>
        <span className="flex-1 truncate text-zinc-900">{selectedName}</span>
        <button
          type="button"
          onClick={() => { onClear(); setQuery('') }}
          className="text-zinc-400 hover:text-zinc-900 shrink-0 leading-none text-base"
        >
          ×
        </button>
      </div>
    )
  }

  return (
    <div className={`relative ${className ?? ''}`}>
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        placeholder={placeholder}
        autoComplete="off"
        className={fieldCls}
      />
      {focused && (
        <div className="absolute z-20 mt-1 w-full border border-zinc-200 bg-white max-h-56 overflow-y-auto shadow-lg">
          {matches.length === 0 ? (
            <p className="px-3 py-2 text-xs text-zinc-400">No matches</p>
          ) : (
            matches.map((item) => (
              <button
                key={item.id}
                type="button"
                onMouseDown={(e) => {
                  e.preventDefault()
                  onPick(item)
                  setFocused(false)
                  setQuery('')
                }}
                className="flex w-full items-center justify-between gap-3 px-3 py-2 text-start text-sm hover:bg-zinc-50 border-b border-zinc-100 last:border-0"
              >
                <span className="truncate">{item.name}</span>
                {item.sub && <span className="text-xs text-zinc-400 shrink-0">{item.sub}</span>}
              </button>
            ))
          )}
        </div>
      )}
    </div>
  )
}
